import React, { useState } from 'react'

import { Button } from 'devextreme-react/button'

import { IxConfirmPopup } from 'components/confirm-popup'


export type IConfirmBtnProps = {
    btnOptions: any,
    onConfirm: () => void,
    title: string,
    description: string,
    confirm?: string,
    cancel?: string,
    name?: string
    confirmPopupVisible?: any
}


export const IxConfirmBtn = ({ btnOptions, onConfirm, title, description, confirm, cancel, name }: IConfirmBtnProps) => {
    const [popupVisible, setPopupVisible] = useState(false)
    const hidePopup = () => setPopupVisible(false)
    const showPopup = () => setPopupVisible(true)
    const handleConfirm = () => {
        onConfirm()
        hidePopup()
    }

    return (
        <>
            <Button {...btnOptions} text={name} onClick={showPopup} />
            <IxConfirmPopup
                popupVisible={popupVisible}
                onHiding={hidePopup}
                onConfirm={handleConfirm}

                confirm={confirm}
                cancel={cancel}

                title={title}
                description={description}
            />
        </>
    )
}
